module.exports = __webpack_public_path__ + "img/moveIcons.fbbb7a6e.png";